// extracted by mini-css-extract-plugin
export var bold = "_rd-0";